var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJackpotStarGoldIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 108,
    viewBox: "0 0 113 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1988 9.85691C50.4258 1.34067 62.5737 1.34066 66.8007 9.8569L73.2121 22.7742C75.6254 27.6363 80.2756 31.0004 85.6487 31.7712L99.8438 33.8076C109.312 35.1658 113.08 46.8153 106.202 53.4613L96.0585 63.2616C92.1249 67.0622 90.3304 72.5652 91.2674 77.9541L93.7038 91.9669C95.3364 101.357 85.4942 108.543 77.0475 104.129L64.1419 97.3847C59.3543 94.8828 53.6452 94.8828 48.8577 97.3847L35.9521 104.129C27.5053 108.543 17.6632 101.357 19.2958 91.9669L21.7322 77.9541C22.6691 72.5652 20.8747 67.0622 16.9411 63.2616L6.79805 53.4613C-0.0804254 46.8153 3.68804 35.1658 13.1558 33.8076L27.3509 31.7712C32.7239 31.0004 37.3741 27.6363 39.7874 22.7742L46.1988 9.85691Z",
    fill: "url(#paint0_linear_971_8318)",
    stroke: "url(#paint1_linear_971_8318)",
    strokeWidth: 5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_971_8318",
    x1: 27.8732,
    y1: 41.205,
    x2: 56.9494,
    y2: 107.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D59130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14375,
    stopColor: "#FCE268"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211458,
    stopColor: "#FFFEC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279167,
    stopColor: "#FFE86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414583,
    stopColor: "#A4601B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607292,
    stopColor: "#B17016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779167,
    stopColor: "#824406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997917,
    stopColor: "#C76254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_971_8318",
    x1: 66.4946,
    y1: 6.55497,
    x2: 25.3965,
    y2: 106.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A68B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6E485"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJackpotStarGoldIcon);
export default __webpack_public_path__ + "static/media/jackpot_star_gold_icon.b9d609e635f19c4614be2a3e59d99634.svg";
export { ForwardRef as ReactComponent };